export default __webpack_public_path__ + "assets/carousel-code-access.78dd84d0ec774f0833a2aff2a3cc36ea.webp";